import { Component, Host, h, Prop } from "@stencil/core";

@Component({
	tag: "smart-plan-badge",
	styleUrl: "smart-plan-badge.scss",
	shadow: true,
})

export class SmartPlanBadge {

	@Prop() regularText!: string;
	@Prop() boldText?: string;

	render() {
		return (
			<Host part="plan-badge-element">
				<smart-text as="span" variant="subtitle-2">
					{this.regularText} {this.boldText && <b>{this.boldText}</b>}
				</smart-text>
			</Host>
		);
	}
}
